import { render, staticRenderFns } from "./ModalEditAttachment.vue?vue&type=template&id=0dfe2303&scoped=true"
import script from "./ModalEditAttachment.vue?vue&type=script&lang=js"
export * from "./ModalEditAttachment.vue?vue&type=script&lang=js"
import style0 from "./ModalEditAttachment.vue?vue&type=style&index=0&id=0dfe2303&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfe2303",
  null
  
)

export default component.exports